<div class="add-user-form">
    <form>
        <div class="row form-row mb-3">
            <div class="col-auto px-0 position-relative">
                <label class="form-label" [class.text-danger]="upsIdError">{{localize(langSection.Term, langText.UpsId)}} *</label>
                <input name="upsId" class="form-control upsid" [class.error]="upsIdError" type="text" [(ngModel)]="user.upsId" (input)="onIdInput($event.target.value)" autocomplete="off">
                @if (upsIdError) {
<span class="error-icon"></span>
}
                @if (upsIdError) {
<p class="text-danger upsid">{{localize(langSection.AddUserPage,
                    langText.InvalidUPSId)}}</p>
}
            </div>
            <div class="col-auto px-0 email position-relative">
                <label class="form-label">{{localize(langSection.Term, langText.Email)}} *</label>
                <input name="email" class="form-control {{errors.email ? 'error': ''}}" type="text" [(ngModel)]="user.email" autocomplete="off">
                @if (errors.email) {
<span class="error-icon"></span>
}
                @if (errors.email) {
<p class="text-danger">{{errors.email}}</p>
}
            </div>
            <div class="col-auto px-0">
                <label class="form-label">{{localize(langSection.Term, langText.Role)}} *</label>
                <ups-select class="role" [list]="roleList" [value]="user.role" (change)="user.role = $event.target.value;">
                </ups-select>
            </div>
        </div>
        <div class="row form-row mb-3">
            <div class="form-group col-auto px-0 search">
                <label class="form-label">{{localize(langSection.AddUserPage, langText.SearchAndAddLocations)}} *</label>
                <location-address-search-input (onSelect)="onLocationSelect($event)"
                    [adminOnly]="true" [clearOnSelect]="true"></location-address-search-input>
            </div>
            <button class="col-auto" [disabled]="!isCurrentUserValid() || upsIdError" (click)="addToQueue();">{{localize(langSection.AddUserPage, langText.AddToQueue)}}</button>
        </div>
    </form>
    <div class="locations">
        @for (location of locations; track location) {
<div class="location">
            <div>{{ formatLocation(location) }}</div>
            <div class="ups-icon ups-icon-x" (click)="removeLocation(location);"></div>
        </div>
}
    </div>
</div>